import React, { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ForgeSelect } from '@tylertech/forge-react';
import {
  selectAssetBrowserFilterValue,
  selectAssetBrowserFilterOptions,
} from 'common/components/AssetBrowser/selectors/filters';
import { SelectDropdownConfig } from '../config/filter-config';
import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import styles from './select-dropdown-filter.module.scss';

export const SelectDropdownFilter = ({ filterConfig }: { filterConfig: SelectDropdownConfig }) => {
  const dispatch: ThunkDispatch<any, unknown, AnyAction> = useDispatch();

  const { label, dispatchAction, getOptions, filterListName, filterName } = filterConfig;

  const value = useSelector(selectAssetBrowserFilterValue(filterName));
  // List only for source and version.
  const selectFilter = useMemo(
    () => selectAssetBrowserFilterOptions<string>(filterListName),
    [filterListName],
  );
  const list = useSelector(selectFilter);

  const options = useMemo(() => getOptions(list), [getOptions, list]);

  /**
   * Select is disabled when there are 2 or less options. (Less than 2 options is not expected.)
   * When there are 2 options (All + one other), show the more specific option instead of the All.
   * If value is undefined, it falls back to null (All).
   */
  const displayValue = options.length === 2 ? options[1].value : value || null;

  const onChange = (e: CustomEvent<string | null>): void => {
    const selectedOption = e.detail;
    dispatch(dispatchAction(selectedOption));
  };

  return (
    <ForgeSelect
      className={styles['select-dropdown-filter']}
      label={label}
      label-position="block-start"
      value={displayValue}
      variant="filled"
      onChange={onChange}
      options={options}
      data-testid={`select-dropdown-${filterConfig.filterName}`}
      disabled={options.length <= 2}
    />
  );
};
